import React from 'react';
import styled from 'styled-components';
import NoImage from 'assets/images/others/no-image.png';

const Container = styled.div`
    position: relative;
    width: 40px;
    height: 40px;
`;

const Image = styled.img<{ $fit?: 'cover' | 'contain' }>`
    border-radius: 4px;
    background: #f3f4f6;
    object-fit: ${(props) => props.$fit ?? 'cover'};
`;

interface ProductThumbnailProps extends Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src' | 'width' | 'height'> {
    url?: string;
    $fit?: 'cover' | 'contain';
}

export function ProductThumbnail({ url, alt = '', ...props }: ProductThumbnailProps) {
    return (
        <Container>
            <Image {...props} src={url || NoImage} alt={alt} width='40' height='40' />
        </Container>
    );
}
